import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LeaveService } from './../../../leave/services/leave.service';
import { EventEmitter } from '@angular/core';
import { subscribeOn } from 'rxjs/operators';
import { Component, Input, OnInit, SimpleChanges, Output } from '@angular/core';
import { AuthComponentModel } from 'app/modules/common/entities/AuthComponentModel';
import { RestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { TaskCreationOperation } from 'app/modules/common/enums/task-create-operation-enum';
import { SharedService } from 'app/modules/common/services/shared-service';
import { Empresa } from 'app/modules/common/types/empresa.type';
import { EmpresaService } from 'app/modules/company-view/services/empresa.service';
import { TaskManagementService } from '../../services/task-management.service';
import { TaskSaveService } from '../../services/task-save.service';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
@Component({
    selector: 'app-task-management',
    templateUrl: './task-management.component.html',
    styleUrls: ['./task-management.component.scss'],
    standalone: false
})
export class TaskManagementComponent implements OnInit {
    @Input() public LeaveId: number;
    @Input() public EmployeeId: number;
    @Input('task-operation') public TaskOperation: TaskCreationOperation =
        TaskCreationOperation.Other;

    public taskList: any = [];
    public authComponentModel = new AuthComponentModel();
    public isShowAutor = false;
    public isShowEnlace = false;

    public todayDate: Date;
    public isShowSme = false;

    public isLoading = false;

    responsibleAuthorTypes:string;
    responsibleModuleName:string;

    citarBajaNueva:string;
    bajaNueva:string;
    leaveInfo: any;
    leaveDate: string;
    LeaveInfo:any;
    constructor(
        private taskSaveService: TaskSaveService,
        public taskManagementService: TaskManagementService,
        public leaveService :LeaveService
    ) {
        this.taskManagementService.initTaskForm(this.LeaveId);
        
    }

    ngOnInit(): void {
        this.getLeave()
            .subscribe(res => {
                this.LeaveInfo = res;
               
            }, err => {
                console.error(err);
            });
        
        this.responsibleAuthorTypes="GCM";
        this.responsibleModuleName="task-managemnt";
        this.taskManagementService.initTaskForm(this.LeaveId);
        this.getDefTareaForTaskDropdown();
        this.getAuthComponentModel();
        this.getEmpresaTieneSME();
        // set default values if task type is not already set
        if (!this.taskManagementService.TaskManagementForm.value.Tarea) {
            this.taskManagementService.setTasksDefaultValues(
                this.TaskOperation
            );
        }

        this.taskManagementService.TaskManagementForm.get("Tarea")?.valueChanges.subscribe(x => {
            this.isShowAutor=true;
        });
        if(this.taskManagementService.TaskManagementForm.get("Tarea")?.value!=undefined)
            {
                if (this.taskManagementService.TaskManagementForm.get("Tarea")?.value == 15001) {
                    this.isShowSme = false;
                }else {
                     this.getEmpresaTieneSME();
                }
                this.isShowAutor=true;
            }else{
                this.getEmpresaTieneSME();
            }
    }

    public getDefTareaForTaskDropdown(): void {
        this.taskSaveService
            .getDefTareaForTaskDropdown(this.LeaveId, this.EmployeeId)
            .subscribe((res) => {
                if (res) {
                    this.taskList = res.result;

                    // listen for changes in the selected task
                    this.taskManagementService.defaultTaskSet.subscribe(
                        (taskId) => {
                            if (taskId) {
                                this.onTaskChange({ value: taskId }, true);
                            }
                        }
                    );
                }
            });
    }

    getLeave(): Observable<any> {
        //const id = this.route.snapshot.paramMap.get('id');
        return this.leaveService.GetLeaveById(this.LeaveId.toString())
            .pipe(map(resp => resp.result), tap(result => {
               this.leaveInfo = result;
               this.leaveDate = DateHelper.getMomentDate(this.leaveInfo?.fbaja).format('DD/MM/YYYY');
            }));
    }

    public getEmpresaTieneSME(): void {
        this.taskSaveService
            .getEmpresaTieneSME(this.LeaveId, this.EmployeeId)
            .subscribe((res) => {
                if (res) {
                    this.isShowSme = res.result === 'S';
                }
            });
    }

    public getAuthComponentModel(): void {
        this.taskSaveService
            .getAuthComponentModel(this.LeaveId, this.EmployeeId)
            .subscribe((res) => {
                if (res) {
                    this.authComponentModel = res.result;
                }
            });
    }

    public onTaskChange(event: { value: any }, showAuthor = true): void {
        this.isLoading = true;
        this.taskManagementService.TaskManagementForm.disable();

        setTimeout(() => {
            const selectedDefTareaId = event.value;
            this.authComponentModel.tasktype = event.value;

            const selectedTask = this.taskList.find(
                (x: { id: any }) => x.id === selectedDefTareaId
            );

            this.taskManagementService.setSelectedTask(selectedTask);

            this.isShowSme = selectedDefTareaId !== 15001;
            this.isShowAutor = showAuthor;

            this.taskManagementService.TaskManagementForm.enable();
            this.isLoading = false;
        }, 3050);
    }
}
